module.exports = __webpack_public_path__ + "open-sans-latin-600italic.3d9980f9fb50821ddcea.eot";


//////////////////
// WEBPACK FOOTER
// /Users/herbert/dev/awesum/awesum-web/~/typeface-open-sans/files/open-sans-latin-600italic.eot
// module id = ../../../../typeface-open-sans/files/open-sans-latin-600italic.eot
// module chunks = 1 3